import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/_services/auth.service';

import { of, switchMap, tap } from 'rxjs';

let isAuthenticated = false;
export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
  const data = inject(AuthService).getDecodedAccessToken(localStorage.getItem('accessToken'));
  if (data == null) {
    return _check(redirectUrl);
  }
  //  else if (data.IsAccountSecurityChanged === 'True') {
  //   const _router = inject(Router);
  //   _router.navigate(['/change-password-sign-in']);
  // }
  else if (_check(redirectUrl) && isAuthenticated) {
    return _checkUserLogin(route, redirectUrl, data);
  }
  // else {
  //   return _check(redirectUrl, data).pipe(
  //     switchMap((authValue) => {
  //       if (authValue && isAuthenticated) return _checkUserLogin(route, redirectUrl, data);
  //       return of(authValue);
  //     })
  //   );
  // }

  // Check the authentication status
};

const _check = (redirectURL, data = null) => {
  const _router = inject(Router);
  const res = inject(AuthService).check();
  const a = of(res).pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page
        _router.navigate(['sign-in'], {
          queryParams: redirectURL === '/home' ? {} : { redirectURL },
        });
        isAuthenticated = false;
        // Prevent the access
        return of(false);
      }
      // if (authenticated) {
      //   const accountSecurityChanged = data && String(data.IsAccountSecurityChanged).toLowerCase() === 'true';
      //   const onChangePassword = redirectURL === '/change-password-sign-in';

      //   // If user is LDAP and must change password, only allow the `change-password-sign-in` route.
      //   if (accountSecurityChanged) {
      //     if (!onChangePassword) {
      //       _router.navigate(['change-password-sign-in']);
      //       isAuthenticated = false;
      //       return of(false);
      //     } else {
      //       // Allow navigation to the change-password page
      //       isAuthenticated = true;
      //       return of(true);
      //     }
      //   }
      // }
      isAuthenticated = true;

      // Allow the access
      return of(true);
    })
  );
  a.subscribe((res) => {});
  return a;
};
const _checkUserLogin = (route: ActivatedRouteSnapshot, url: any, data: any) => {
  const userRole = JSON.parse(data.Roles);
  if (route.data.role) {
    if (Array.isArray(route.data.role)) {
      let found = [];
      route.data.role.forEach((element) => {
        let data = userRole.filter((e) => e.Name == element);
        data.length > 0 ? found.push(data) : '';
      });
      if (found.length == route.data.role.length) {
        return of(true);
      } else {
        inject(Router).navigate([branding()]);
      }
    } else if (userRole.filter((e) => e.Name == route.data.role).length == 0) {
      inject(Router).navigate([branding()]);
      return of(false);
    }
  } else {
    return of(true);
  }
};
const branding = () => {
  // brand = window.location.hostname.replace(/\./g, '');
  let brand = window.location.hostname.split('.');

  return brand[0].includes('fieldpal') ? '/signed-in-redirect' : 'home';
  //return true;
};
